import { render, staticRenderFns } from "./PlanAlokasi.vue?vue&type=template&id=65e32cb6&scoped=true&"
import script from "./PlanAlokasi.vue?vue&type=script&lang=js&"
export * from "./PlanAlokasi.vue?vue&type=script&lang=js&"
import style0 from "./PlanAlokasi.vue?vue&type=style&index=0&id=65e32cb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e32cb6",
  null
  
)

export default component.exports